
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"14","height":"15","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_11766_128)"}},[_c('path',{attrs:{"d":"M12.059 2.11l.33.331a.654.654 0 010 .927l-.795.799-1.26-1.26.795-.796a.654.654 0 01.927 0h.003zM5.737 7.506l3.67-3.672 1.26 1.26-3.672 3.67a.654.654 0 01-.285.167l-1.6.457.457-1.6a.654.654 0 01.167-.284l.003.002zm4.465-6.321L4.807 6.576c-.238.238-.41.53-.5.85l-.782 2.735a.656.656 0 00.812.812l2.734-.782c.323-.093.615-.266.85-.5l5.395-5.393a1.969 1.969 0 000-2.784l-.33-.33a1.969 1.969 0 00-2.784 0zM2.406 2.25A2.406 2.406 0 000 4.656v7.438A2.406 2.406 0 002.406 14.5h7.438a2.406 2.406 0 002.406-2.406V9.03a.655.655 0 00-.656-.656.655.655 0 00-.656.656v3.063c0 .604-.49 1.094-1.094 1.094H2.406c-.604 0-1.094-.49-1.094-1.094V4.656c0-.604.49-1.093 1.094-1.093H5.47a.655.655 0 00.656-.657.655.655 0 00-.656-.656H2.406z","fill":"#1C2F45"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11766_128"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(0 .5)","d":"M0 0h14v14H0z"}})])])])
          )
        }
      }
    